import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getStore } from '@/util/store'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]

      /**
       *
       *------国际化的配置规范------
       *在locales目录下可以配置不同语言的json文件
       *可以添加跟json同名的文件夹en，会自动解析成对象加入对应的en对象
       *en文件夹内的json文件不要与外面en.json内有冲突
       *
       * */

      const { input } = matched
      if (input.match(/\//g).length > 1) {
        messages[input.match(/\/(\S*)\//)[1]][locale] = locales(key)
      } else {
        messages[locale] = locales(key)
      }
    }
  })
  console.log(messages, '------------------I18N------------------')
  return messages
}
export default new VueI18n({
  locale: getStore({ name: 'language' }) || 'en',
  fallbackLocale: getStore({ name: 'language' }) || 'en',
  messages: loadLocaleMessages(),
})
